import { App } from "./App.model";
import { UserInfo } from "./WorkspaceData.model";

export interface Invitation {
  id: string;
  created: string;
  expires_at: string;
  email: string;
  role: MemberRole;
}

export interface Member {
  id: string;
  team: {
    id: string;
    slug: string;
    name: string;
  };
  role: MemberRole;
  user: UserInfo;
  apps: App[];
}

export enum MemberRole {
  ADMIN = "admin",
  MEMBER = "member",
  GUEST = "guest",
  AI = "ai",
}

export const getRoleAsText = (role: MemberRole) => {
  switch (role) {
    case MemberRole.ADMIN:
      return "Admin";
    case MemberRole.GUEST:
      return "Guest";
    case MemberRole.AI:
      return "AI agent";
    default:
      return "Member";
  }
};

export const isAdmin = (role?: MemberRole) => {
  return role === MemberRole.ADMIN;
};

export const isMember = (role?: MemberRole) => {
  return role === MemberRole.MEMBER;
};

export const isGuest = (role?: MemberRole) => {
  return role === MemberRole.GUEST;
};
